import { render, staticRenderFns } from "./Security.vue?vue&type=template&id=18eecb6a&scoped=true&"
import script from "./Security.vue?vue&type=script&lang=ts&"
export * from "./Security.vue?vue&type=script&lang=ts&"
import style0 from "./Security.vue?vue&type=style&index=0&id=18eecb6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18eecb6a",
  null
  
)

export default component.exports